import api from 'services/api'

import {
  ADD_FAVOURITES_API_SUCCESS,
  ADD_FAVOURITES_API_FAIL,
  REMOVE_FAVOURITES_API_SUCCESS,
  REMOVE_FAVOURITES_API_FAIL,
} from 'src/services/app-state/personalizedRecommendation/constants'

const addFavouritesAPISuccess = data => ({
  type: ADD_FAVOURITES_API_SUCCESS,
  data,
})
const addFavouritesAPIFail = error => ({
  type: ADD_FAVOURITES_API_FAIL,
  error,
})

const removeFavouritesAPISuccess = data => ({
  type: REMOVE_FAVOURITES_API_SUCCESS,
  data,
})

const removeFavouritesAPIFail = error => ({
  type: REMOVE_FAVOURITES_API_FAIL,
  error,
})

export const addFavourites = (params, id) => dispatch =>
  api
    .request('addFavourites', { appendPath: id, ...params })
    .then((response) => {
      dispatch(addFavouritesAPISuccess({ ...response, ...params }))
    })
    .catch((error) => {
      dispatch(addFavouritesAPIFail(error))
    })
export const removeFavourites = (params, id) => dispatch =>
  api
    .request(`removeFavourites`, { appendPath: id, ...params })
    .then(response => dispatch(removeFavouritesAPISuccess({ ...response, ...params })))
    .catch((error) => {
      dispatch(removeFavouritesAPIFail(error))
    })

export const fetchFavouritesItemList = () => (dispatch, store) => {
  const {
    profile: {
      profileId,
    },
  } = store()

  return api.request('viewFavouritesItemListV2', {
    appendPath: profileId,
    headers: { 'X-FAV-DC-ENV': 'PUBLIC' },
  })
}



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/actions/favourites.js